import styled from 'styled-components';

import { Typography } from '../../display/Typography';

export const SelectorContainer = styled.fieldset`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  border: none;
  padding: 0;
  margin: 1rem 0;
  width: 100%;
`;

export const Legend = styled.legend`
  font-size: 1.4rem;
  font-weight: 600;
  /* El <legend> NO es un flex item (el navegador lo trata como caption del
     fieldset), así que el gap del contenedor no lo separa de las opciones:
     la separación tiene que venir de su propio margin-bottom. */
  margin-bottom: 1.2rem;
  color: ${({ theme }) => theme.colors.black};
`;

export const OptionsRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1.6rem;
`;

export const OptionRow = styled.label<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  flex: 1 1 16rem;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  /* El radio nunca debe encogerse (en el modal estrecho de descarga ZIP el
     flex lo aplastaba a óvalo). */
  & > input {
    flex-shrink: 0;
  }
`;

export const OptionLabel = styled(Typography)`
  display: flex;
  flex-direction: column;
`;

export const OptionHint = styled.span`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.darkGrey};
  font-weight: 400;
`;
